<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  created() {
    window.document.title = "武汉青年创业中心";
  }
}
</script>
<style lang="scss">
html{
  --window-top: 44px;
  --window-bottom: 60px;
}
div, p, i, span, ul, li, ol, img, input, button, textarea{
  box-sizing: border-box;
}
#app {
  font-size: 14px;
}
</style>
